import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    content: {
      marginTop: 20,
    },
    rootTabs: {
      width: '100%',
      borderBottom: `1px solid ${palette.lightGray}`,
    },

    tabsYellow: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navCompanyContextActions,
      },
    },
    tabsGreen: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navAdminActions,
      },
    },
    tabsGray: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navSuperAdminActions,
      },
    },
    tabsBlue: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navOperatorActions,
      },
    },

    tab: {
      fontSize: 12,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'end',
      color: palette.darkGray,

      '&:hover': {
        textDecoration: 'none',
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabYellow: {
      '&.Mui-selected': {
        color: palette.navCompanyContextActions,
      },
    },
    tabGreen: {
      '&.Mui-selected': {
        color: palette.navAdminActions,
      },
    },
    tabGray: {
      '&.Mui-selected': {
        color: palette.navSuperAdminActions,
      },
    },
    tabBlue: {
      '&.Mui-selected': {
        color: palette.navOperatorActions,
      },
    },
  });
